import { render, staticRenderFns } from "./checkbimVideo.vue?vue&type=template&id=10a2f5ea&scoped=true&"
import script from "./checkbimVideo.vue?vue&type=script&lang=js&"
export * from "./checkbimVideo.vue?vue&type=script&lang=js&"
import style0 from "./checkbimVideo.vue?vue&type=style&index=0&id=10a2f5ea&scoped=true&lang=css&"
import style1 from "./checkbimVideo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2f5ea",
  null
  
)

export default component.exports